import React, {useState, useEffect} from 'react';
import {
  useHistory
} from "react-router-dom";
import {
  ResourceList,
  Thumbnail,
  ResourceItem,
  TextStyle,
  Page,
  Card,
  SkeletonBodyText,
  Stack,
  Button, Icon, Toast, Frame
} from '@shopify/polaris';
import {DeleteMinor, ImportMinor, ViewMinor, ClockMinor, SettingsMinor, ShipmentMajor} from '@shopify/polaris-icons';
import {productService} from '../services/product';
import {shippingService} from '../services/shipping';
import {blogService} from '../services/blog';

interface AccountProps {
  onAction(): void;
}

export default function Home(props: any) {

  const [productGroups, setProductGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSyncingProducts, setIsSyncingProducts] = useState(false);
  const [isSyncingShipping, setIsSyncingShipping] = useState(false);
  const [singleSyncingShipping, setSingleSyncingShipping] :any = useState({});
  const [isToastActive, setIsToastActive] = useState(false);
  const [productSyncStatus, setProductSyncStatus] = useState('');
  const [shippingSyncStatus, setShippingSyncStatus] = useState('');
  const [singleShippingSyncStatus, setSingleShippingSyncStatus] :any = useState('');
  const [singleSyncEnabled, setSingleSyncEnabled] :any = useState(false);
  const [singleSyncId, setSingleSyncId] :any = useState("");

  const history = useHistory();

  const syncProducts = () => {
    setIsSyncingProducts(true);
    productService.sync().then( (data) => {
      const { job_id } = data;
      if(job_id) {
        // SSE - sever sent events init
        const source = new EventSource(`/api/sync/status?clientId=${job_id}`);

        source.addEventListener('syncUpdate', (message: any) => {
          //const { data } = message;
          const { status } = JSON.parse(message.data);
          if( status != 'pending' ) {
            setIsSyncingProducts(false);
            setIsToastActive(true);
            source.close();
            setProductSyncStatus(status);
          }
        });

        source.onmessage = e => {
          console.log('on message', e);
        }
        source.onerror = () => {
          // error log here
          console.log('on error');
          setIsSyncingProducts(false);
          
          source.close();
        }
      }
    });

  };
  const syncSingleProduct = (id: any, handle: any) => {
    console.log("ID ==>>", id, handle);
    setSingleSyncId(id);
    setSingleSyncingShipping((prevState :any) => ({
      ...prevState,
      [id]: true,
    })); 
    setSingleSyncEnabled(true);   
    shippingService.syncShippingLabels(id, handle).then( (data) => {
      const { job_id } = data;
      if(job_id) {
        console.log(job_id);
        startSingleSSE(job_id, id);
      }
    });
  };
  const syncShipping = ()=>{

    setIsSyncingShipping(true);
    shippingService.sync().then( (data) => {
      const { job_id } = data;
      if(job_id) {
        startSSE(job_id);
      }
    });

  }

  const startSSE = (job_id:any)=>{
      // SSE - sever sent events init
      const source = new EventSource(`/api/shipping-meta/variants/all/status?clientId=${job_id}`);

      source.addEventListener('syncUpdate', (message: any) => {
        //const { data } = message;
        const { status } = JSON.parse(message.data);
        if( status != 'pending' ) {
          setIsSyncingShipping(false);
          setIsToastActive(true);
          source.close();
          setShippingSyncStatus(status);
        }
        if(status == 'pending'){
          console.log("Still Syncing PLease wait")
          setIsSyncingShipping(true)
        }
      });

      source.onmessage = e => {
        console.log('on message', e);
      }
      source.onerror = (e) => {
        // error log here
        console.log('on error',e);
        setIsSyncingShipping(false);
        
        source.close();
      }
  }
  const startSingleSSE = (job_id:any, id :any)=>{
    // SSE - sever sent events init
    const source = new EventSource(`/api/shipping-meta/variants/all/status?clientId=${job_id}`);

    source.addEventListener('syncUpdate', (message: any) => {
      //const { data } = message;
      const { status } = JSON.parse(message.data);
      if( status != 'pending' ) {
        setSingleSyncingShipping((prevState :any) => ({
          ...prevState,
          [id]: false,
        })); 
        setIsToastActive(true);
        setSingleSyncEnabled(false);   
        source.close();
        setSingleShippingSyncStatus(status);
      }
      if(status == 'pending'){
        console.log("Still Syncing PLease wait")
        setSingleSyncingShipping((prevState :any) => ({
          ...prevState,
          [id]: true,
        })); 
       }
    });

    source.onmessage = e => {
      console.log('on message', e);
    }
    source.onerror = (e) => {
      // error log here
      console.log('on error',e);
      setSingleSyncingShipping((prevState :any) => ({
        ...prevState,
        [id]: true,
      }));       
      source.close();
    }
}

  const primaryAction = {content: 'New Group', url: '/product-group/new'};
  const secondaryActions = [
    {content: 'Sync Products', icon: ImportMinor, loading: isSyncingProducts, onAction: syncProducts},
    {content: 'Sync Shipping Tags', icon: ImportMinor, loading: isSyncingShipping, onAction: syncShipping},
    {content: 'Sync Tutorials', icon: ImportMinor, onAction: () => { blogService.sync(); }},
    {content: 'Delivery Estimates', icon: ClockMinor, url: '/delivery-estimate'},
    {content: 'Delivery Settings', icon: SettingsMinor, url: '/delivery-estimate/settings'}
  ];
  
  /*const choiceListItems = [
    {label: 'I accept the Terms of Service', value: 'false'},
    {label: 'I consent to receiving emails', value: 'false2'},
  ];*/

  useEffect(() => {
    productService.groups().then(products => {
      setProductGroups(products);
      setIsLoading(false);
    })
  }, []);

  useEffect(() => {

    shippingService.getSyncJob().then(status=>{
      console.log("Jobs Status ==>>",status);
      if(!status.job_id)
      {      
        console.log(status.message);
      }else{

        console.log(status.job_id);
        startSSE(status.job_id);


      }

    })
    shippingService.getSingleSyncJob().then(status=>{
      console.log("Single Shipping Jobs Status ==>>",status);
      if(!status.job_id)
      {      
        console.log(status.message);
      }else{

        console.log(status?.type?.split("_").pop());
        let id = status?.type?.split("_").pop();
        if(id){
          setSingleSyncId(id);
          setSingleSyncingShipping((prevState :any) => ({
            ...prevState,
            [id]: true,
          })); 
          setSingleSyncEnabled(true);  
          startSingleSSE(status.job_id, id);
        }
      
      }

    })
    // shippingService.syncStatus().then(products => {
    //   setProductGroups(products);
    //   setIsLoading(false);
    // })
  }, []);


  const removeProductGroup = (id: any, handle: string) => {
    return function remove(){
      console.log(id, productGroups.filter(item => id === item['id']));
      setProductGroups(productGroups.filter(item => id !== item['id']));
      productService.removeGroup(handle).then(() => {
      });
    }
  }

  const toastMarkup = isToastActive && productSyncStatus != '' 
  ? <Toast duration={2000} content={'Sync ' + productSyncStatus} onDismiss={() => { setIsToastActive(false); }} error={productSyncStatus == 'failed' ? true : false} /> 
  : shippingSyncStatus != '' ? <Toast duration={1000} content={'Sync ' + shippingSyncStatus} onDismiss={() => { setIsToastActive(false); }} error={shippingSyncStatus == 'failed' ? true : false} />
  : singleShippingSyncStatus != '' ? <Toast duration={1000} content={'Sync ' + singleShippingSyncStatus} onDismiss={() => { setIsToastActive(false); }} error={singleShippingSyncStatus == 'failed' ? true : false} /> : null;

  return (
    <Frame>
    <Page
    title="Product Groups"
    //breadcrumbs={breadcrumbs}
    primaryAction={primaryAction}
    secondaryActions={secondaryActions}
  >
    
    <Card sectioned>
      {isLoading ? (<SkeletonBodyText lines={3} />) : (
        <ResourceList
          resourceName={{singular: 'product', plural: 'products'}}
          items={productGroups}
          renderItem={(item) => {
            const {id, title, image, variants, handle}: { id: any, title: string, image: any, variants: any[], handle: string } = item;
            const media = (<Thumbnail source={image && image.hasOwnProperty('src') ? image.src : window.location.origin +  '/placeholder.png'} alt={title} />);

            return (
              <ResourceItem
                id={id}
                onClick={(e) => {
                }}
                media={media}
                accessibilityLabel={`View details for ${title}`}
              >
                <Stack alignment="center" key={id}>
                  <Stack.Item fill>
                    <h3>
                      <TextStyle variation="strong">{title}</TextStyle>
                    </h3>
                    <div>{variants.length} variants</div>
                  </Stack.Item>
                  <Stack.Item>
                  {/* <Button icon={(<Icon color={'highlight'} source={ShipmentMajor} />)} size="slim" onClick={() => {
                     history.push(`/shipping-meta/variants/${handle}`);
                  }}></Button> */}
                  <Button disabled={singleSyncEnabled} loading={singleSyncingShipping[id]} icon={(<Icon color={'highlight'} source={ImportMinor} />)} size="slim" onClick={()=>syncSingleProduct(id, handle)}></Button>
                  <Button primary icon={(<Icon source={ClockMinor} />)} size="slim" onClick={() => {
                     history.push(`/delivery-estimate/product/${handle}`);
                  }}></Button>
                  <Button icon={(<Icon source={ViewMinor} />)} size="slim" onClick={() => {
                     history.push(`/product/${handle}`);
                  }}></Button>
                  <Button destructive icon={(<Icon source={DeleteMinor} />)} size="slim" onClick={removeProductGroup(id, handle)}></Button>
                  </Stack.Item>
                </Stack>
              </ResourceItem>
            )
          }}
        />
      )}
    </Card>
    {toastMarkup}
  </Page>
  </Frame>
  );
}
